export class VehicleBrakeMeasurementQueryParameters {
  gmBrakeCode?: string;
  id?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  sort?: string;

  constructor(obj?: VehicleBrakeMeasurementQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
